import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (!req.url.startsWith(environment.colab.apiBaseUrl)) {
    // only intercept Colab API requests
    // It also intercepts requests to the auth server (tnrIdentity)
    return next(req);
  }

  const sessionToken = inject(AuthService).sessionToken();
  if (!sessionToken) {
    return next(req);
  }

  const newReq = req.clone({
    headers: req.headers.append('sessionToken', sessionToken)
  });
  return next(newReq);
}
